export enum HolidayType {
ByLaw,
Company,
Speciality,
}
